export const isValidEmail = (email: string): boolean => {
    // Serious validation
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

export const isStrongPassword = (password: string): boolean => {
    // At least 1 uppercase letter, 1 lowercase letter, at least 1 digit, at least 1 special character, minimum eight in length
    const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    return regex.test(password);
}

const hasRequiredLength = (value: string, length: number): boolean => {
    // at least length characters
    return value.length >= length;
}

const hasRequiredNonLetterOrDigit = (value: string, requiredNonLetterOrDigit: boolean): boolean => {
    if (!requiredNonLetterOrDigit) {
        return true;
    }

    // contains character other than letter or digit
    const regex = /[^\w]/g;
    return regex.test(value);
}

const hasRequiredDigit = (value: string, requiredDigit: boolean): boolean => {
    if (!requiredDigit) {
        return true;
    }

    // contains at least 1 digit
    const regex = /\d/;
    return regex.test(value);
}

const hasRequiredUpperCase = (value: string, requiredUpperCase: boolean): boolean => {
    if (!requiredUpperCase) {
        return true;
    }

    // contains at least 1 uppercase letter
    return value.toLowerCase() !== value;
}

const hasRequiredLowerCase = (value: string, requiredLowerCase: boolean): boolean => {
    if (!requiredLowerCase) {
        return true;
    }

    // contains at least 1 lowercase letter
    return value.toUpperCase() !== value;

}

export const isValidPassword = (password: string) => {
    return hasRequiredLength(password, (window as any).passwordValidation.passwordRequiredLength)
        && hasRequiredNonLetterOrDigit(password, (window as any).passwordValidation.passwordRequireNonLetterOrDigit)
        && hasRequiredDigit(password, (window as any).passwordValidation.passwordRequireDigit)
        && hasRequiredUpperCase(password, (window as any).passwordValidation.passwordRequireUpperCase)
        && hasRequiredLowerCase(password, (window as any).passwordValidation.passwordRequireLowerCase);
}

export const hasNonAsciiCharacters = (value: string): boolean => {
    // matches any character within the ASCII range (including extended ascii) (space (char code 32) to ÿ ( char code 255)))
    const asciiRegex = /^[ -ÿ]*$/; 
    return !asciiRegex.test(value);
}